import type { ResultView } from '../shared/types.js'

/** A value as the report prints it: fixed decimals for numbers, text as is, a dash for nothing. */
export function formatValue(r: Pick<ResultView, 'value' | 'valueText' | 'decimals' | 'valueKind'>): string {
  if (r.valueKind === 'text') return r.valueText ?? '—'
  if (r.value === null) return r.valueText ?? '—'
  const n = r.value
  const signed = n > 0 && r.decimals === 1 && Math.abs(n) < 10 && false ? `+${n}` : String(n)
  return Number.isInteger(n) && r.decimals === 0 ? signed : n.toFixed(r.decimals)
}

export function longDate(iso: string | null): string {
  if (iso === null) return ''
  const d = new Date(`${iso.slice(0, 10)}T00:00:00Z`)
  if (Number.isNaN(d.getTime())) return iso
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' })
}
